import { useLocation } from 'react-router-dom';

import useEffectOnce from 'hooks/use-effect-once';
import { useLocale } from 'state/intl';
import { inferHasShownLanguageSelector as userSelectedLocale } from 'state/intl/hook';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { isKiosk } from 'utils/environment';
import { routes } from 'utils/routing';

import { fetchUserLocale } from './fetch-user-locale';

export const useSetUserLocale = () => {
  const { pathname } = useLocation();
  const isLocalizationDisabled = useFlag(LaunchDarklyFlag.DISABLE_LOCALIZATION);
  const enableAutoLocale = !!useFlag(LaunchDarklyFlag.ENABLE_AUTO_LOCALE);
  const enableAutoShowRegionSelector = useFlag(LaunchDarklyFlag.ENABLE_AUTO_SHOW_REGION_SELECTOR);
  const isDeployPreview = pathname.includes('preview-');
  const {
    clearRegionSpecificStorage,
    region: currentRegion,
    locale: currentLocale,
    setShowLanguageSelectorModal,
    setHasShownLocaleSelector,
    inferLanguage,
    determiningLocaleComplete,
    setDeterminingLocaleComplete,
  } = useLocale();

  const blacklistedLangModalRoute = [routes.confirmJwt, routes.store].some(route =>
    pathname.includes(route)
  );

  const shouldFetchLocale =
    !isLocalizationDisabled &&
    !userSelectedLocale() &&
    !blacklistedLangModalRoute &&
    !isKiosk &&
    !determiningLocaleComplete;

  useEffectOnce(() => {
    if (enableAutoLocale && shouldFetchLocale) {
      fetchUserLocale({
        currentRegion,
        currentLocale,
        clearRegionSpecificStorage,
        enableAutoShowRegionSelector,
        setShowLanguageSelectorModal,
        setHasShownLocaleSelector,
        isDeployPreview,
        inferLanguage,
        setDeterminingLocaleComplete,
      });
    }
  });
};
